export class DraftError extends Error {}
